module.exports = __webpack_public_path__ + "img/15.a923e4ea.png";